document.addEventListener('DOMContentLoaded', function() {
    document.getElementById('scrollToTopBtn').addEventListener('click', function() {
        scrollToTop(1000); 
    });

    function scrollToTop(duration) {
        const start = window.scrollY;
        const startTime = performance.now();

        function scroll() {
            const currentTime = performance.now();
            const timeElapsed = currentTime - startTime;
            const progress = Math.min(timeElapsed / duration, 1);

            window.scrollTo(0, start * (1 - progress));

            if (timeElapsed < duration) {
                requestAnimationFrame(scroll);
            }
        }

        requestAnimationFrame(scroll);
    }
});